export default "__VITE_ASSET__324avszb__"